<template>
    <div class="new_door_model">
        <div class="door_model_content">
            <ul class="door_model_info">
                <li class="door_model_info_item">
                    <div style="border: none;background: #ffffff;margin: 0;padding: 0;">
                        <i style="color:#F56C6C;padding-right:6px;">*</i>
                        <span>户型</span>
                    </div>
                    <div>
                        <input type="number" v-model="doorModelInfo.roomNumber" name />
                        <span>室</span>
                        <input type="number" v-model="doorModelInfo.officeNumber" name />
                        <span>厅</span>
                        <input type="number" v-model="doorModelInfo.toiletNumber" name />
                        <span>卫</span>
                        <input type="number" v-model="doorModelInfo.balconyNumber" name />
                        <span>阳</span>
                    </div>
                </li>
                <li class="door_model_area">
                    <!--                    <div class="door_model_area_title">-->
                    <div style="border: none;background: #ffffff;margin: 0;padding: 0;">
                        <i style="color:#F56C6C;padding-right:6px;">*</i>
                        <span>面积</span>
                    </div>
                    <!-- <el-switch v-model="value3" :inactive-text="inactiveText" @change="openCheckBtn">
                        </el-switch>-->
                    <!--                    </div>-->
                    <div class="door_model_input">
                        <!--  <div class="check_no" v-if="!value3">
              <input type="number" name="">
              <span>㎡</span>
                        </div>-->
                        <div class="check_ture">
                            <div class="check_ture_item">
                                <input style="width: 60px" placeholder="建筑面积" v-model="doorModelInfo.areaOfBuilding"
                                    type="number" name />
                                <span>㎡</span>
                            </div>
                            <div class="check_ture_item">
                                <input style="width: 60px" placeholder="套内面积" v-model="doorModelInfo.areaOfUse"
                                    type="number" name />
                                <span>㎡</span>
                            </div>
                            <div class="check_ture_item">
                                <input disabled="true" style="width: 60px" placeholder="分摊面积" v-model="fentan"
                                    type="number" name />
                                <span>㎡</span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <ul class="upload_img">
                <li class="upload_img_box" v-show="dataUrl">
                    <img width="100%" :src="dataUrl" alt />
                    <p class="up_text" v-show="isUpload">正在上传...</p>
                </li>
                <li class="upload_img_box" v-show="!dataUrl">
                    <el-upload :action="`${$uploadUrl}/erp/qiniu/uploadImg`" :before-upload="beforeUpload"
                        :data="uploadData" :show-file-list="false" :on-success="handleAvatarSuccess" :headers="headers"
                        accept=".png, .jpg, .jpeg">
                        <img v-if="doorModelInfo.images[0].url" :src="doorModelInfo.images[0].url" class="avatar" />
                        <i v-else class="iconfont icon-icon_huxing"></i>
                    </el-upload>
                    <!-- <input type="file" name="file" ref="fileInput" @change="add_img" class="upload_input_invisible" accept="image/*"> -->
                    <!-- <i class="iconfont icon-icon_huxing"></i> -->
                    <span v-if="!doorModelInfo.images">上传户型</span>
                </li>
            </ul>
        </div>
        <ul class="door_modle_introduced">
            <li class="introduced_toward">
                <span>朝向</span>
                <el-select v-model="doorModelInfo.orientation" placeholder="请选择" @visible-change="getTowardData">
                    <el-option v-for="(item,index) in towardData" :key="index" :label="item.valueDesc"
                        :value="item.value"></el-option>
                </el-select>
            </li>
            <!-- <li class="introduced_toward">
        <span>小区介绍</span>
        <el-input v-model="doorModelInfo.description" type='textarea' resize="none"></el-input>
            </li>-->
        </ul>
        <div class="introduced_btns">
            <button @click="removeDoorBtn">取消</button>
            <button v-points @click="saveDoorBtn(doorModelInfo)" class="save_btn">保存</button>
        </div>
    </div>
</template>
<script type="text/javascript">
import VueCookies from "vue-cookies";
import axios from "axios";
import { dicGet } from "@/api";
import { Loading } from "element-ui";
export default {
    name: "",
    data() {
        let token = sessionStorage.getItem("accessToken") || "";
        return {
            dataUrl: "",
            dialogVisible: false,
            value3: false,
            isUpload: true,
            inactiveText: "不校验",

            towardData: [],
            doorModelInfo: {
                residentialAreaId: "",
                images: [
                    {
                        uri: "",
                        size: "",
                        url: "",
                    },
                ], // 图片链接 query string
                // imageResource[0].title: '' ,//鼠标悬浮图片上的内容 query string
                roomNumber: "", // required) 室数 query integer
                officeNumber: "", // required) 厅数 query integer
                toiletNumber: "", // required) 卫数 query integer
                balconyNumber: "", // required) 阳台数 query integer
                kitchenNumber: "", //厨数
                areaOfBuilding: "", // required) 建筑面积 query double
                areaMeasureCheck: 1, // 是否套内面积校验 query string
                areaOfUse: "", // 套内面积query double
                orientation: "", // (//required) 朝向 1: 东 2: 南 3: 西 4: 北 5: 东南 6: 东西 7: 东北 8: 西南 9: 西北 10: 南北 11: 其他 query string
                residentialAreaId: "", // required) 小区编号 query integer
                description: "", // 型描述query string
            },
            uploadData: {
                // modularName: "houseTypeImage",
                modularName: "05",
            },
            imageUrl: "",
            headers: {
                accessToken: token,
            },
        };
    },
    methods: {
        beforeUpload(file){
            if (file.size / 1024 / 1024 > 8){}else {
                Loading.service({ background: 'transparent', text: '拼命上传中' });
            }
        },
        handleAvatarSuccess(res, file) {
            if (res.code == 200) {
                this.doorModelInfo.images[0].url = URL.createObjectURL(
                    file.raw
                );
                this.doorModelInfo.images[0].uri = res.uri;
                this.doorModelInfo.images[0].size = res.size;
            } else {
                this.$message.error(res.msg);
            }

            Loading.service({ background: "transparent" }).close();
        },

        // 获取朝向
        getTowardData(val) {
            if (val) {
                let params = {
                    code: "orientation",
                };
                this.$post(dicGet, params).then((res) => {
                    if (res.success) {
                        this.towardData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                        });
                    }
                });
            }
        },
        openCheckBtn(val) {
            //cosole.log(this.value3)
            if (val) {
                this.inactiveText = "校验";
                this.doorModelInfo.areaMeasureCheck = 0;
                return;
            }
            if (!val) {
                this.inactiveText = "不校验";
                this.doorModelInfo.areaMeasureCheck = 1;
            }
        },
        removeDoorBtn() {
            this.$emit("removeDoorBtn");
        },
        saveDoorBtn(doorModelInfo) {
            this.$emit("saveDoorBtn", doorModelInfo);
        },
    },
    computed: {
        fentan() {
            return this.doorModelInfo.areaOfBuilding &&
                this.doorModelInfo.areaOfUse
                ? (this.doorModelInfo.areaOfBuilding -
                    this.doorModelInfo.areaOfUse).toFixed(4)
                : "分摊面积";
        },
    },
};
</script>
<style lang="less">
.new_door_model {
    .el-upload {
        width: 140px;
        height: 100px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        line-height: 100px;
    }
    .el-select {
        margin-top: 10px;
        .el-input {
            .el-input__inner {
                padding-left: 10px !important;
                font-size: 16px !important;
                width: 100px !important;
                height: 30px !important;
                background: #f5f5f5;
                border: 1px solid #ccc !important;
            }
            .el-input__icon {
                line-height: 30px;
            }
        }
    }
}
</style>
<style type="text/css" lang="less" scoped >
.avatar {
    width: 140px;
    height: 102px;
    display: block;
}
.new_door_model {
    .door_model_content {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        .door_model_info {
            font-size: 14px;
            color: #333333;
            padding-left: 0 !important;
            .door_model_info_item {
                > div {
                    width: 190px;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    background: #f5f5f5;
                    margin-top: 10px;
                    border-radius: 4px;
                    overflow: hidden;
                    border: 1px solid #ccc;
                    input {
                        width: 30px;
                        height: 100%;
                        background: #f5f5f5;
                        outline: none;
                        text-align: center;
                    }
                    input::-webkit-outer-spin-button,
                    input::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                    }
                    input[type="number"] {
                        -moz-appearance: textfield;
                    }
                }
            }
            .door_model_area {
                margin-top: 20px;
                .door_model_area_title {
                    display: flex;
                    justify-content: space-between;
                    .el-switch {
                        line-height: 14px;
                        .el-switch__core {
                            height: 14px;
                            width: 30px !important;
                        }
                        .el-switch__core:after {
                            width: 10px;
                            height: 10px;
                        }
                        .el-switch__label {
                            color: #5e75e6;
                        }
                        .el-switch__label * {
                            font-size: 12px;
                        }
                        .el-switch__label.is-active {
                            color: #333333;
                        }
                    }
                    .el-switch.is-checked .el-switch__core::after {
                        margin-left: -10px;
                    }
                }
                .door_model_input {
                    width: 280px;
                    height: 30px;
                    background: #f5f5f5;
                    border-radius: 4px;
                    overflow: hidden;
                    margin-top: 10px;
                    border: 1px solid #ccc;
                    .check_no {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0 10px;
                        > input {
                            background: #f5f5f5;
                            height: 100%;
                            flex: 1;
                            outline: none;
                        }
                        input::-webkit-outer-spin-button,
                        input::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                        }
                        input[type="number"] {
                            -moz-appearance: textfield;
                        }
                        span {
                            font-size: 14px;
                            color: #333333;
                        }
                    }
                    .check_ture {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        .check_ture_item {
                            flex: 1;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 10px;
                            > input {
                                width: 100%;
                                height: 100%;
                                background: #f5f5f5;
                                outline: none;
                            }
                            input::-webkit-outer-spin-button,
                            input::-webkit-inner-spin-button {
                                -webkit-appearance: none;
                            }
                            input[type="number"] {
                                -moz-appearance: textfield;
                            }
                        }
                        .check_ture_item:first-child,
                        .check_ture_item:nth-child(2) {
                            border-right: 1px solid #ccc;
                        }
                    }
                }
            }
        }
        .upload_img {
            border: 1px solid red;
            width: 140px;
            height: 100px;
            background: #f5f5f5;
            border: 1px solid #cccccc;
            border-radius: 4px;
            .upload_img_box {
                width: 140px;
                height: 100px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                .upload_input_invisible {
                    position: absolute;
                    border: 1px solid red;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
                .icon-icon_huxing {
                    font-size: 28px;
                    color: #999999;
                }
                > span {
                    font-size: 14px;
                }
                .up_text {
                    position: absolute;
                    bottom: 0;
                    height: 30px;
                    color: black;
                    font-weight: 600;
                    text-align: center;
                    line-height: 30px;
                    font-size: 14px;
                    width: 100%;
                    background: white;
                    opacity: 0.5;
                }
            }
        }
    }
    .door_modle_introduced {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        .introduced_toward {
            display: flex;
            flex-direction: column;
            > span {
                font-size: 14px;
                color: #333333;
            }

            .el-textarea {
                margin-top: 10px;
                .el-textarea__inner {
                    width: 260px;
                    height: 60px;
                    background: #f5f5f5;
                    border: 1px solid #ccc;
                }
            }
        }
    }
    .introduced_btns {
        height: 80px;
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 40px;
        background: #f5f5f5;

        > button {
            width: 80px;
            height: 40px;
            outline: none;
            border: none;
            background: #999999;
            margin-left: 20px;
            border-radius: 4px;
            font-size: 16px;
            color: white;

            &.save_btn {
                background: #5e75e6;
            }
        }
    }
}
</style>
